import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

export const GuaranteeBadge = ({ size = 220 }) => (
  <div className="relative shrink-0" style={{ width: size, height: size }} data-testid="guarantee-badge">
    <motion.svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full" animate={{ rotate: 360 }}
      transition={{ duration: 40, repeat: Infinity, ease: "linear" }} aria-hidden="true">
      <defs><path id="circ" d="M100,100 m-82,0 a82,82 0 1,1 164,0 a82,82 0 1,1 -164,0" /></defs>
      <text fill="#a1a1aa" fontSize="11.5" letterSpacing="4.2" fontFamily="Outfit">
        <textPath href="#circ">7-DAY MONEY-BACK GUARANTEE · NO QUESTIONS ASKED · </textPath>
      </text>
    </motion.svg>
    <div className="absolute inset-[22%] flex flex-col items-center justify-center rounded-full border border-line bg-[#0b0b0b]">
      <span className="font-display text-5xl font-semibold leading-none text-white">7</span>
      <span className="eyebrow mt-1 !text-[10px]">days</span>
    </div>
  </div>
);

export const GuaranteeLine = () => (
  <p className="flex items-center gap-2 text-sm text-zinc-300" data-testid="guarantee-line">
    <ShieldCheck size={16} className="text-white" /> 7-day money-back guarantee. Full refund, no questions.
  </p>
);
